import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { ClienteDropDown } from "../../../../../../common/domain/models/cliente_dropdown";
import { useMemo } from "react";
import { DefaultCheckBox } from "../../../../../../common/components/default_checkbox";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { DefaultSelectInput } from "../../../../../../common/components/default_select_input";

import CascateList from "../../../../../../common/components/cascate_list";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DefaultInput from "../../../../../../common/components/default_input";

/**
 * Header
 */

type Props = {
  preencher: boolean;
  centroCustos: number[] | null;
  status: number;
  clientes: number[] | null;
  pesquisaClientes: string | null;
  centroCustosDropdown: CentroCustoDropDown[];
  clientesDropdown: ClienteDropDown[];
  onPreencherChange: (value: boolean) => void;
  onCentroCustosChange: (value: number[] | null) => void;
  onStatusChange: (value: number) => void;
  onClientesChange: (value: number[] | null) => void;
  onPesquisaClienteChange: (value: string | null) => void;
  onClearFilters: () => void;
};

export const Header = ({
  preencher,
  centroCustos,
  status,
  clientes,
  pesquisaClientes,
  centroCustosDropdown,
  clientesDropdown,
  onPreencherChange,
  onCentroCustosChange,
  onStatusChange,
  onClientesChange,
  onPesquisaClienteChange,
  onClearFilters,
}: Props) => {

  const selectedCentroCustos = useMemo(() => {
    if (centroCustos === null || centroCustos.length === 0) return null;
    if (centroCustosDropdown.length === 0) return null;
    return centroCustosDropdown.filter(x => centroCustos.some(y => y === x.id));
  }, [
    centroCustos,
    centroCustosDropdown,
  ]);

  const selectedClientes = useMemo(() => {
    if (clientes === null || clientes.length === 0) return null;
    if (clientesDropdown.length === 0) return null;
    return clientesDropdown.filter(x => clientes.some(y => y === x.id));
  }, [
    clientes,
    clientesDropdown,
  ]);

  const statusOptions = useMemo(() => {
    return [
      {
        id: 2,
        label: 'Todas',
      },
      {
        id: 1,
        label: 'Realizadas',
      },
      {
        id: 0,
        label: 'Em Aberto',
      },
    ];
  }, [
  ]);

  return (
    <CascateList title='Filtros' defaultOpen={true}>
      <div className="w-full flex flex-col gap-2">
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-x-2 gap-y-4">
          <DefaultMultiAutocomplete
            label='Centro de Custos'
            options={centroCustosDropdown}
            getOptionKey={x => x.id}
            getOptionLabel={x => x.title}
            value={selectedCentroCustos}
            onChange={e => onCentroCustosChange(e !== null ? e.map(x => x.id) : null)}
          />

          <DefaultSelectInput
            name='status'
            label='Status'
            showSelectionLabel={false}
            options={statusOptions}
            value={status}
            onChangeValue={e => onStatusChange(Number(e))}
          />

          <div className="flex flex-col">
            <div className="h-[2.5rem]">
              {
                preencher === false
                  ? (
                    <DefaultMultiAutocomplete
                      label='Clientes'
                      options={clientesDropdown}
                      getOptionKey={x => x.id}
                      getOptionLabel={x => x.title}
                      value={selectedClientes}
                      onChange={e => onClientesChange(e !== null ? e.map(x => x.id) : null)}
                    />
                  ) : (
                    <DefaultInput
                      name='pesquisarCliente'
                      label='Clientes'
                      value={pesquisaClientes}
                      onChangeValue={e => onPesquisaClienteChange(e)}
                    />
                  )
              }
            </div>

            <DefaultCheckBox
              name='clientePreenchido'
              label='Cliente preenchido'
              value={preencher}
              onChangeValue={e => onPreencherChange(e)}
            />
          </div>

        </div>

        <div className="w-full flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClearFilters}>
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
}